import React from "react";
import withContext from "../utils/withContext";
import * as versions from "./version";

export class MainImage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            adVisible: !versions.isVersionC(props.context.fprVersion),
        };
    }

    setAdVisible() {
        this.setState({ adVisible: false });
    }

    render() {
        const imgUrl = this.props.news.image;
        const fullNewsUrl = this.props.fullNewsUrl;
        const isReloaded = this.props.isReloaded;

        return (
            <div className="main-news-wrap">
                <div className="main-news-wrap__blur" style={{ backgroundImage: `url("${imgUrl}")` }}></div>
                <div className="main-news-wrap__img-wrap">
                    {isReloaded ? (
                        <a href={fullNewsUrl.toString()} target="_blank">
                            <img className="main-news-img" src={imgUrl} />
                        </a>
                    ) : (
                        <img className="main-news-img" src={imgUrl} />
                    )}
                </div>
            </div>
        );
    }
}

export default withContext(MainImage);
